import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AnimatePresence, domMax, LazyMotion } from "framer-motion";
import React, { useRef } from "react";
import { createPortal } from "react-dom";
import { Overlay } from "../../components/Overlay";
import { animationHandler, animationMap, animationVariants } from "../../util/animationToolkit";
import getPortalRoot from "../../util/getPortalRoot";
import { StyledModalWrapper } from "./ModalContext";
export function ModalV2(_param) {
    var isOpen = _param.isOpen, onDismiss = _param.onDismiss, closeOnOverlayClick = _param.closeOnOverlayClick, children = _param.children, props = _object_without_properties(_param, [
        "isOpen",
        "onDismiss",
        "closeOnOverlayClick",
        "children"
    ]);
    var animationRef = useRef(null);
    var handleOverlayDismiss = function() {
        if (closeOnOverlayClick) {
            onDismiss === null || onDismiss === void 0 ? void 0 : onDismiss();
        }
    };
    var portal = getPortalRoot();
    if (portal) {
        if (!isOpen) return null;
        return /*#__PURE__*/ createPortal(/*#__PURE__*/ _jsx(LazyMotion, {
            features: domMax,
            children: /*#__PURE__*/ _jsx(AnimatePresence, {
                children: /*#__PURE__*/ _jsxs(StyledModalWrapper, _object_spread_props(_object_spread(_object_spread_props(_object_spread({
                    ref: animationRef,
                    // @ts-ignore
                    onAnimationStart: function() {
                        return animationHandler(animationRef.current);
                    }
                }, animationMap), {
                    variants: animationVariants,
                    transition: {
                        duration: 0.3
                    }
                }), props), {
                    children: [
                        /*#__PURE__*/ _jsx(Overlay, {
                            onClick: handleOverlayDismiss
                        }),
                        children
                    ]
                }))
            })
        }), portal);
    }
    return null;
}
